module.exports = __webpack_public_path__ + "static/media/image_placeholder.8317a719.png";